// === Vue 主要載入區 ===
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // 路由模組，用來處理各頁面導向
import "@fortawesome/fontawesome-free/css/all.min.css"; // Font Awesome 圖示
import "@mdi/font/css/materialdesignicons.min.css"; // MDI 圖示

// ✅ 新增：引入 vueuse/head（SEO 動態設定）
import { createHead } from "@vueuse/head"; // 這是 SEO 重點套件

// === 建立 Vue 應用 ===
const app = createApp(App); // 建立主應用實例

// === 建立 Head 實例 ===
const head = createHead(); // 建立 head 管理器（處理 <title>、<meta> 等）

// === 掛載外部套件 ===
app.use(router); // 啟用路由
app.use(head); // 啟用 Head 管理（SEO）⭐

// === 掛載至 DOM ===
app.mount("#app"); // 掛載到 index.html 裡的 #app 節點
